import React, { useEffect, useState } from 'react';
import Map from './map/Map';
import data from './assets/data/ProjectData.json';
import symbolConfigList from './assets/config/symbolConfig.json';
import { Button } from '@mui/material';
import './style.scss';
import applicationMode from './helper/applicationMode';
import layerTypeEnums from './helper/enums/layerTypeEnums';
const apiKey = "AIzaSyDjsRkkfAa5PY6bt_x0nnAcD4zjopgQBXU";



const firebaseConfig = {
    FirebaseConfig: process.env.REACT_APP_FIREBASE_CONFIG,
    FirebaseServiceAccount: process.env.REACT_APP_SERVICE_ACCOUNT,
    FirebaseWebAPIKey: process.env.REACT_APP_WEB_API_KEY,
    DatabaseName: 'oem_dev',
    // TenantName: 'demo'
    TenantName: 'demo3'
};

export default function App() {
   
    const [mapData, setMapData] = useState();
    const [symbolConfig, setSymbolConfig] = useState();
    const [isClustered, setIsClustered] = React.useState('');
    const [mapOptions, setMapOptions] = React.useState({
        CenterLat: 44.967243,
        CenterLng: -103.771556,
        Zoom: 4,
        IsCluster: false,
        // ClusterBy: 'Discriminator',
        // ClusterAlgorithm: 'GridAlgorithm',
        "ClusterAlgorithm": "SuperClusterAlgorithm",
        ClusterSize: 50,
        ClusterMaxZoom: 15,
        MapType: 'roadmap', //roadmap, satellite, hybrid, terrain,
        LegendTitle: 'SUPPLIER STATES',
        DrawingEnabled: false,
        LegendEnabled: true,
        InfoWindowEnabled: true,
        MeasureEnabled: true,
        WorkspaceEnabled: false,
        MapTypeControl: true,
        FullScreenControl: false,
        RotateControl: false,
        ZoomControl: true,
        StreetViewControl: true,
        Draggable: true,
        Scrollwheel: true,
        ApplicationMode: applicationMode.custom,
        // MapId: 'd7ae9211f10efc8a',
        MapId: 'ae71ad07651ecc9',
        Enable3DMode: false
    });

    useEffect(() => {
        if (data) {
            setMapData(data);
        }
    }, [data]);

    useEffect(() => {
        if (symbolConfigList) {
            setSymbolConfig(symbolConfigList);
        }
    }, [symbolConfigList]);

    useEffect(() => {
        const setcluster = mapOptions?.IsCluster ? true : false;
        setIsClustered(setcluster);
    }, [mapOptions]);

    return (
        <>
            
            <div className="map-container">
                <Map
                    apiKey={apiKey}
                    mapData={null}
                    mapOptions={mapOptions}
                    symbolConfig={symbolConfig}
                    layerData={null}
                    firebaseConfig={firebaseConfig}
                />
            </div>
        </>
    );
}
